import { useState } from 'react'
import DisclaimerHeader from '../../components/DisclaimerHeader'
import DisclaimerBody from '../../components/DisclaimerBody'
import LoginHeader from '../../components/LoginHeader'
import TalkdeskFooter from '../../components/TalkdeskFooter'
import LoginBody from '../../components/LoginBody'
import SideIllustration from '../../components/SideIllustration'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import { useViewport } from '@talkdesk/cobalt-react-viewport-provider'
import styles from '../Base/Base.module.css'

const LoginPage = ({
  csrf,
  localLoginEnabled,
  identityProviders,
  showCaptcha,
  showGoogleFooterLink,
  siteKey,
  email,
  brandAssetsURL,
  brandingSettings,
  talkdeskIdAssetsURL,
  marketingBannerURL,
  marketingBannerTimeout,
  sidebannerEnabled,
  disclaimerEnabled,
}) => {
  const viewport = useViewport()
  const isSmallViewport = viewport === 'small' || viewport === 'medium'
  const [showDisclaimer, setShowDisclaimer] = useState(disclaimerEnabled)

  const onDisclaimerAcknowledged = () => setShowDisclaimer((prev) => !prev)

  const hasIdentityProviders = Object.keys(identityProviders).length !== 0
  const showSidebanner = sidebannerEnabled && !isSmallViewport
  const [hasShownSidebanner, setHasShownSidebanner] = useState(showSidebanner)
  if (showSidebanner && !hasShownSidebanner) setHasShownSidebanner(true)

  return (
    <Flex
      direction='column'
      height='100vh'
      width='100%'
      backgroundColor='white'
      scrollable
    >
      <Flex grow alignY='stretch' width='100%'>
        <Flex direction='column' width={showSidebanner ? '60%' : '100%'}>
          <Flex grow alignX='center' alignY='center' width='100%'>
            <Box paddingX={4} className={styles.containerWidth}>
              {showDisclaimer ? (
                <>
                  <DisclaimerHeader brandingSettings={brandingSettings} />
                  <DisclaimerBody onAcknowledge={onDisclaimerAcknowledged} />
                </>
              ) : (
                <>
                  <LoginHeader
                    localLoginEnabled={localLoginEnabled}
                    brandingSettings={brandingSettings}
                  />
                  <LoginBody
                    brandAssetsURL={brandAssetsURL}
                    brandingSettings={brandingSettings}
                    localLoginEnabled={localLoginEnabled}
                    csrf={csrf}
                    showCaptcha={showCaptcha}
                    siteKey={siteKey}
                    email={email}
                    identityProviders={identityProviders}
                    hasIdentityProviders={hasIdentityProviders}
                  />
                </>
              )}
            </Box>
          </Flex>
          <TalkdeskFooter
            brandingSettings={brandingSettings}
            showGoogleFooterLink={showGoogleFooterLink}
          />
        </Flex>
        {sidebannerEnabled && (
          <Flex
            width={showSidebanner ? '40%' : '0'}
            style={{ overflow: 'hidden' }}
          >
            {hasShownSidebanner && (
              <SideIllustration
                talkdeskIdAssetsURL={talkdeskIdAssetsURL}
                marketingBannerURL={marketingBannerURL}
                marketingBannerTimeout={marketingBannerTimeout}
              />
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default LoginPage
